/** @format */

import { createGlobalStyle } from "styled-components";

// @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');
export const GlobalStyles = createGlobalStyle`

      *{
            box-sizing: border-box;

      }
      html{
            scrollbar-width: normal;
      }
      html::-webkit-scrollbar{
            width:.7em;
      }
      html::-webkit-scrollbar-thumb{
      background: #cecece;
      border-radius:1em;
}
   html::-webkit-scrollbar-thumb:hover{
      background: #000;
}
      html::-webkit-scrollbar-track{
      background: #fff;
}


      body{
      background: ${({ theme }: any) => theme.colors.bg};
      font-family: 'Poppins';
      margin: 0;
      color:${({ theme }) => theme.colors.text};
      font-weight: 500;
      width: 100%;

}
      img{
      max-width: 100%;
}
`;
